jQuery(document).ready(function ($) {
  if ($("body").hasClass("single-product")) {
    Fancybox.bind(".dco-image-attachment a", {
      infobar: false,
    });
  }
  if ($("body").hasClass("single-post")) {
    Fancybox.bind(".gallery a", {
      groupAll: true,
    });
  }
});
